export default "__VITE_ASSET__bee0bc5e__"